opnun = window.opnun || {};

opnun.days = {
	getAvailable: function (callback) {
		$.ajax({
			'type': 'get',
			'url': '/_/moya/opnun/ajax/requestavailabledays'
		}).done(function(r) {
			opnun.days.available = r.split(',');
			callback();
		});
	},
	isAvailable: function (date) {
		if (opnun.days.available == '*') {
			return [true];
		}

		var m = date.getMonth(), d = date.getDate(), y = date.getFullYear();
		for (i = 0; i < opnun.days.available.length; i++) {
			var day = d + '-' + (m+1) + '-' + y;
			if ($.inArray(day, opnun.days.available) !== -1) {
				return [true];
			}
		}

		return [false];
	}
};

opnun.timeslot = {
	getAvailable: function (date, callback) {
		$.ajax({
			'type': 'get',
			'url': '/_/moya/opnun/ajax/requesttimeslots',
			'data': {
				date: date
			}
		}).done(function(r) {
			opnun.timeslot.available = r;
			callback();
		});
	}
};

opnun.fullcalendar = {
	init: function (element, options) {
		$(element).fullCalendar({
			monthNames: options.monthNames,
			monthNamesShort: options.monthNamesShort,
			dayNames: options.dayNames,
			dayNamesShort: options.dayNamesShort,
			buttonText: options.buttonText,
			timeFormat: options.timeFormat,
			events: {
				url: options.source,
				cache: true
			},
			dayClick: options.dayClick ? options.dayClick : opnun.fullcalendar.createDayClick(element),
			eventClick: options.eventClick ? options.eventClick : opnun.fullcalendar.createEventClick(element),
		});
	},
	createDayClick: function(element) {
		return function (date, jsEvent, view, resource) {
			var d = new Date(date);
			var url = '/_/moya/opnun/ajax/requestdateform?date=' + d.getTime() / 1000;
			var dateString = d.getDate() + '.' + parseInt(d.getMonth() + 1) + '.' + d.getFullYear();
			var $dialog = $('.calendarEventDialog');
			$dialog
				.load(url, null, function () {
					$dialog.find('form').on('submit', function (e) {
						e.preventDefault();

						var $form = $(this),
							data = $form.serialize()

						$.ajax({
							method: "POST",
							url: "/_/moya/opnun/ajax/savedate",
							data: data
						}).done(function (r) {
							$(element).fullCalendar('refetchEvents');
							$dialog.dialog("close");
						});
					});

					$dialog.find('#cancel').attr('onclick', '').on('click', function (e) {
						e.preventDefault();
						$dialog.dialog("close");
					});
				})
				.dialog({
					width: '50%',
					title: dateString,
					resize: 'auto',
					draggable: false
				});
		}
	},
	createEventClick: function(element) {
		return function (calEvent, jsEvent, view) {
			if (calEvent.url) {
				var url = '/_'+calEvent.url.replace('/is', '');
				var $dialog = $('.calendarEventDialog');
				$dialog
					.load(url, null, function() {
						$dialog.find('form').on('submit', function(e) {
							e.preventDefault();

							var $form = $(this),
								data = $form.serialize(),
								date = new Date(calEvent.start),
								ts = date.getTime()/1000;

							data += '&ts='+ts;

							$.ajax({
								method: "POST",
								url: "/_/moya/opnun/ajax/deletedate",
								data: data
							}).done(function(r) {
								$(element).fullCalendar('refetchEvents');
								$dialog.dialog("close");
							});
						});

						$dialog.find('#cancel').attr('onclick', '').on('click', function(e) {
							e.preventDefault();
							$dialog.dialog("close");
						});
					})
					.dialog({
						width:'50%',
						title:calEvent.title,
						resize: 'auto',
						draggable: false
					});

				return false;
			}
		}
	}
};

/*
$(function() {
	$('#tsFrom').datepicker({
		dateFormat: 'dd.mm.yy',
		onClose: function( selectedDate ) {
			$( "#tsTo" ).datepicker( "option", "minDate", selectedDate );
		}
	});
	$('#tsTo').datepicker({
		dateFormat: 'dd.mm.yy'
	});
});
*/